export default "__VITE_ASSET__DmaVfL$t__"